export default function MenuSection() {
  return (
    <section id="menu" className="bg-[#1A1A1A] py-24 px-6 md:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
          <div>
            <p className="text-[#FF6B35] text-xs font-semibold tracking-[0.25em] uppercase mb-3">Our Menu</p>
            <h2 className="text-[#FAF8F5] font-extrabold text-4xl md:text-5xl leading-tight">
              Fresh Dough,<br />
              <span className="text-[#8B6F47]">Quality Ingredients</span>
            </h2>
          </div>
          <p className="text-[#FAF8F5]/50 text-base max-w-xs leading-relaxed">
            Handmade pizzas and hearty meals — made to share and remember.
          </p>
        </div>

        {/* Menu Link CTA */}
        <div className="flex flex-col items-center justify-center py-16 gap-6">
          <p className="text-[#FAF8F5]/60 text-lg text-center max-w-md leading-relaxed">
            Browse our full menu — from handmade pizzas to burgers, fish &amp; chips, salads, and Icelandic lamb chops.
          </p>
          <a
            href="https://www.gallerypizza.is/#/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#FF6B35] text-[#1A1A1A] font-bold text-base px-10 py-4 rounded-full hover:bg-[#e55a24] transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap tracking-wider uppercase"
          >
            <i className="ri-restaurant-line text-lg" />
            View Full Menu
          </a>
          <p className="text-[#FAF8F5]/30 text-xs tracking-widest uppercase">gallerypizza.is</p>
        </div>
      </div>
    </section>
  );
}
